"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.solidButtonStyles = exports.outlineButtonStyles = exports.loadingStyles = void 0;
var _styledComponents = require("styled-components");
var _tokens = require("../../tokens");
var _constants = require("./constants");
const growFade = (0, _styledComponents.keyframes)(["0%{transform:scaleX(0);}60%{transform:scaleX(1);opacity:1;}100%{opacity:0;}"]);
const loadingStyles = (foreground, background) => (0, _styledComponents.css)(["overflow:hidden;", ""], _ref => {
  let {
    loading
  } = _ref;
  return loading && (0, _styledComponents.css)(["position:relative;z-index:1;background-color:", ";&:before{z-index:-1;content:'';position:absolute;top:0;left:0;bottom:0;right:0;pointer-events:none;background:", ";transform-origin:0% 0%;animation:", " 1.5s ease-in-out infinite;}"], background, foreground, growFade);
});
exports.loadingStyles = loadingStyles;
const solidButtonStyles = exports.solidButtonStyles = (0, _styledComponents.css)(["", " ", ""], _ref2 => {
  let {
    size
  } = _ref2;
  return `
    font-size: ${_constants.SIZE[size].fontSize};
    line-height: ${_constants.SIZE[size].lineHeight};
    padding: ${_constants.SIZE[size].padding.map(p => `${p}px`).join(' ')};
  `;
}, _ref3 => {
  let {
    loading
  } = _ref3;
  return !loading && `
    &:disabled {
      background-color: ${_tokens.COLOR.GREY.LIGHT};
      color: ${_tokens.COLOR.GREY.DARK};
    }
  `;
});
const outlineButtonStyles = exports.outlineButtonStyles = (0, _styledComponents.css)(["", " ", ""], _ref4 => {
  let {
    size
  } = _ref4;
  return `
    font-size: ${_constants.SIZE[size].fontSize};
    line-height: ${_constants.SIZE[size].lineHeight};
    padding: ${_constants.SIZE[size].padding.map(p => `${p - _constants.BORDER_WIDTH}px`).join(' ')};
    border: ${_constants.BORDER_WIDTH}px solid transparent;
  `;
}, _ref5 => {
  let {
    loading
  } = _ref5;
  return !loading && `
    &:disabled {
      background-color: ${_tokens.COLOR.WHITE};
      border-color: ${_tokens.COLOR.GREY.LIGHT};
      color: ${_tokens.COLOR.GREY.MEDIUM};
    }
  `;
});